import { init } from "commandbar";
import { api } from "./axios";
import { config } from "./config";
import { getIdToken } from "./firebase";

let isInitialized = false;

export const initCommandBar = () => {
	if (isInitialized || config.isLocal) return;
	if (!config.commandbar.orgId) {
		console.warn("CommandBar org ID not configured");
		return;
	}
	init(config.commandbar.orgId);
	isInitialized = true;
};

export const bootCommandBar = async () => {
	if (!isInitialized) return;

	try {
		const [authResponse, firebaseToken] = await Promise.all([
			api.post("/auth/commandbar-auth"),
			getIdToken(),
		]);

		const { userId, hash, user } = authResponse.data;

		window.CommandBar.boot(
			userId,
			{
				email: user.email,
				name: `${user.firstName} ${user.lastName}`.trim(),
				admin: user.admin,
			},
			{
				hmac: hash,
				copilotAPIHeaders: {
					Authorization: `Bearer ${firebaseToken}`,
				},
			},
		);
	} catch (error) {
		console.error("Failed to boot CommandBar:", error);
	}
};

export const shutdownCommandBar = () => {
	if (window.CommandBar) {
		window.CommandBar.shutdown();
	}
};
